import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DataDrivenDecisions = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h1 className="banner-title">Data-Driven Decisions</h1>
          <p>
            Unlock the full potential of your business with our data analytics
            solutions. <br /> Harness the power of data to make informed decisions that
            drive growth, optimize operations, and deliver measurable results.
          </p>
          <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/employee-working-marketing-setting_23-2151871176.jpg?t=st=1731837295~exp=1731840895~hmac=cf801bbcd93aeaa06785daed77db7baf4c3df6616db79a178d21753dc882080d&w=360"
          alt="Data-Driven Decision Making"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="text-center">Overview</h2>
              <p className="text-center">
                Our data analytics solutions empower organizations to leverage
                the power of data for informed decision-making. By integrating
                advanced analytics, AI, and machine learning, we help businesses
                optimize their processes, uncover actionable insights, and create
                a competitive edge.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid bg-light" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Case Studies</h2>
              <p className="text-center mb-0">
                Here are some real-world examples where our data-driven solutions
                made a significant impact on business outcomes.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Retail Data Analytics</h4>
              <p className="mb-4">
                By implementing predictive analytics in retail data, a major
                retailer gained real-time insights into customer behavior and
                demand forecasting. This led to better stock management and
                improved customer satisfaction through timely product availability,
                increasing revenue by 20%.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Financial Portfolio Optimization</h4>
              <p className="mb-4">
                A financial institution used advanced data modeling to optimize
                its clients' investment portfolios. With machine learning-based
                algorithms, they could predict market trends and adjust investments
                accordingly, leading to a 15% increase in returns for their clients.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Healthcare Predictive Analytics</h4>
              <p className="mb-4">
                We helped a healthcare provider use predictive analytics to forecast patient admissions, improving resource allocation and reducing emergency room congestion by 30%.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h4 className="mb-3 card-title">Supply Chain Optimization</h4>
              <p className="mb-4">
                Using AI-powered analytics, a logistics company was able to predict
                delays in the supply chain and optimize delivery routes. The result
                was a 25% reduction in delivery times and a significant decrease in
                operational costs.
              </p>
            </div>
          </div>
        </div>
      </div>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 bg-black text-white mx-0 px-4">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2>Ready to Make Data-Driven Decisions?</h2>
                <p className="mt-3">
                  Schedule a consultation today to explore how we can empower
                  your growth with data-driven insights.
                </p>
                <button className="banner-button mt-3">
  <Link to="/contact" className="text-decoration-none text-white">
    Let’s talk <span className="arrow">→</span>
  </Link>
</button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Data Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataDrivenDecisions;
